import React, { Component } from 'react';
import ComponentsPark from '../ComponentsPark/ComponentsPark';

class Parks extends Component {
    render() {
        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding-only-small-screen">
                <ComponentsPark />
            </div>
        )
    }
}

export default Parks;
